import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import {
    tableDataVM,
    tableFiltersVM,
    tableStateVM,
    tableStatsVM,
    tableViewVM,
} from '../../../core/table/table_view_models';
import {
    splitOrderInvoicesDetailTableStateAtom,
    splitOrderInvoicesDetailTableViewAtom,
    splitOrderInvoicesDetailLineItemsAtom,
    splitOrderInvoicesDetailTableStatsAtom,
    splitOrderInvoicesDetailTableFiltersAtom,
} from './split_order_invoices_detail_atoms';
import {
    splitOrderInvoiceLineItemsAllColumnsView,
    splitOrderInvoiceLineItemsColumnSpec,
} from './SplitOrderInvoiceLineItemsTableSpec';
import { tblSpecLoadView } from '../../../core/table/tableViewsRepo';
import { ListTableInitHookReturn } from '../../../core/table/table.types';
import { SplitOrderInvoicesDetailLineItem } from './split_order_invoices_detail_types';

export const useSplitOrderInvoiceLineItemsTableInit = (): ListTableInitHookReturn => {
    const [init, setInit] = useState(true);
    const setState = useSetImmerAtom(splitOrderInvoicesDetailTableStateAtom);
    const setView = useSetImmerAtom(splitOrderInvoicesDetailTableViewAtom);
    const setList = useSetImmerAtom(splitOrderInvoicesDetailLineItemsAtom);
    const setStats = useSetImmerAtom(splitOrderInvoicesDetailTableStatsAtom);
    const setFilter = useSetImmerAtom(splitOrderInvoicesDetailTableFiltersAtom);

    useEffect(() => {
        setState(draft => {
            if (init && !draft.waiting) {
                setInit(false);
                const colSpec = splitOrderInvoiceLineItemsColumnSpec();
                const defaultView = splitOrderInvoiceLineItemsAllColumnsView();
                const loadedView = tblSpecLoadView(defaultView.key, [defaultView], colSpec);
                draft.views = [defaultView];
                draft.currentViewId = defaultView.key;
                setView(() => loadedView || tableViewVM());
                return draft;
            }
        });
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        return (): void => {
            setState(() => tableStateVM());
            setView(() => tableViewVM());
            setFilter(() => tableFiltersVM());
            setStats(() => tableStatsVM());
            setList(() => tableDataVM<SplitOrderInvoicesDetailLineItem>());
        };
    }, [setFilter, setList, setState, setStats, setView]);

    return { init };
};
